import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Checkbox, Form, Radio, Select } from 'antd';
import Balance from '../../../../../assets/Balance.jsx';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import ZaroPayQR from "./ZaroPayQR.jsx"
import { ZaropayDepositAmountApi } from '../../../../../api/request/wallet/deposit.js';
import { BankOutlined, DownOutlined, WalletOutlined } from '@ant-design/icons';
import useTermsAndConditions from '../../../../../hooks/useTermsAndConditions.js';
import { handleApiError } from '../../../../../utils/handleApiError.js';

const ZaroPayMobile = ({ amount, paymentMethod, accounts, resetAll, tncFileUrl, loginTerminalId, validateAmount }) => {
    const [form] = Form.useForm();
    const { userDetails } = useSelector(state => state.user);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [isDepositLoading, setIsDepositLoading] = useState(false);
    const [depositdata, setDepositdata] = useState(null);
    const [step, setStep] = useState(1);
    const { tnc } = useTermsAndConditions();

    const handleSubmit = async (values) => {
        setIsDepositLoading(true);
        try {
            if (validateAmount) {
                toast.error(validateAmount);
                return;
            }
            if (!amount) {
                toast.error('Please enter deposit amount');
                return;
            }
            const isWallet = loginTerminalId === 'wallet';
            const deposiParams = {
                userId: userDetails?._id,
                paymentGatwayId: paymentMethod?.id,
                amount: Number(amount),
                loginTerminalId: isWallet ? 0 : loginTerminalId,
            };
            const { data } = await ZaropayDepositAmountApi(deposiParams);
            if (data?.success) {
                form.resetFields();
                setDepositdata(data?.data);
                setStep(2);
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setIsDepositLoading(false);
        }
    };
    console.log("accounts--", accounts)
    return (
        <div>
            {step === 1 && (
                <Form form={form} layout='vertical' className='space-y-5 mb-6' onFinish={handleSubmit}>
                    <div className="mb-4">
                        <div className="relative">
                            {/* <Select
                                value={selectedAccount}
                                onChange={setSelectedAccount}
                                className="w-full !bg-white rounded-xl"
                                size="large"
                                suffixIcon={<div className="flex items-center justify-center h-full w-full"><DownOutlined className="text-gray-400 bg-[#F5F9FD] p-2.5 rounded-lg" /></div>}
                                placeholder="Select Account"
                                popupClassName="custom-select-dropdown"
                                dropdownAlign={{ offset: [0, 0] }}
                                dropdownStyle={{
                                    borderRadius: '16px',
                                    padding: '8px',
                                    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
                                    border: 'none',
                                    marginTop: '-10px'
                                }}
                            >
                                {[{ login: "Wallet" }, ...accounts].map(item => (
                                    <Select.Option
                                        key={item?.login}
                                        value={item?.login}
                                        label={<span className="primary font-semibold text-sm">{item?.name}</span>}
                                    >
                                        <div className="flex items-center gap-2 py-1 px-2 rounded-lg">
                                            {item?.login === "Wallet" ? <WalletOutlined size={24} /> : <BankOutlined size={24} />}
                                            <span className={`font-semibold text-sm`}>
                                                {item?.login} {item?.login !== "Wallet" ? `($${item?.balance || 0})` : ''}
                                            </span>
                                        </div>
                                    </Select.Option>
                                ))}
                            </Select> */}
                        </div>
                    </div>

                    <Form.Item
                        name='conditions'
                        valuePropName="checked"
                        rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')) }]}
                    >
                        <div className="flex items-center gap-2">
                            <Checkbox className='m-0'>Yes, I agreed to the</Checkbox>
                            <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300'>Terms and conditions</Link>
                        </div>
                    </Form.Item>

                    <LoadableButton
                        className='block bg-primary w-full text-sm text-white font-semibold rounded-lg px-12 py-3 uppercase themeHover duration-500'
                        type="submit"
                        lable='Next'
                        isLoading={isDepositLoading}
                    />
                </Form>
            )}

            {step === 2 && (
                <ZaroPayQR depositdata={depositdata} resetAll={resetAll} />
            )}
        </div>
    )
}

export default ZaroPayMobile
